// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 910) return "static/chunks/52271efe-8943ccd391c54af5.js";
	if (chunkId === 989) return "static/chunks/989-6397e65656347b27.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7":"03ff874a21b40687","63":"1eb76688268f4e06","69":"6fd359eb347de0c2","83":"2f65ce6690d15c93","314":"6588425baf6d45b4","316":"3d40a4b7a3e4f83d","546":"13bf97ad7c3af9e9","622":"a0670dd00b31582d","687":"d9dba4ec9607235e","945":"d58ef1bb2dfd20cf","953":"678fe07f3a81d03e"}[chunkId] + ".js";
};